import * as React from 'react';

// Style
import './Box.css';

// Declarations
type levels = 1 | 2 | 3 | 4 | 5;

// Component
export interface IProps {
    pa?: levels;
    px?: levels;
    py?: levels;
    pt?: levels;
    pr?: levels;
    pb?: levels;
    pl?: levels;
    ma?: levels;
    mx?: levels;
    my?: levels;
    mt?: levels;
    mr?: levels;
    mb?: levels;
    ml?: levels;
    align?: 'left' | 'center' | 'right';
    color?: 'contrast';
    style?: React.CSSProperties;
    children?:  React.ReactNode | Array<React.ReactNode>;
}
function Box(props: IProps) {
    const classes = ['Box'];
    if (props.pa) { classes.push(`pa-${props.pa}`); }
    if (props.px) { classes.push(`px-${props.px}`); }
    if (props.py) { classes.push(`py-${props.py}`); }
    if (props.pt) { classes.push(`pt-${props.pt}`); }
    if (props.pb) { classes.push(`pb-${props.pb}`); }
    if (props.pl) { classes.push(`pl-${props.pl}`); }
    if (props.ma) { classes.push(`ma-${props.ma}`); }
    if (props.mx) { classes.push(`mx-${props.mx}`); }
    if (props.my) { classes.push(`my-${props.my}`); }
    if (props.mt) { classes.push(`mt-${props.mt}`); }
    if (props.mr) { classes.push(`mr-${props.mr}`); }
    if (props.mb) { classes.push(`mb-${props.mb}`); }
    if (props.ml) { classes.push(`ml-${props.ml}`); }
    if (props.align) { classes.push(`align-${props.align}`); }
    if (props.color) { classes.push(`color-${props.color}`); }
    return (
        <div className={classes.join(' ')} style={props.style}>{props.children}</div>
    );
}

export default Box;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Box/Box.tsx